import React from "react";
import { CheckBox } from "devextreme-react/check-box";
import "./style.scss";
import { formatMessage } from "devextreme/localization";

export default function Insurance({ employee = {}, convertDateTime }) {
  return (
    <div>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <CheckBox
            defaultValue={employee?.IsSocialInsurance}
            readOnly={true}
            text={formatMessage("JoinSocialInsurance")}
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={employee?.IsHealthyInsurance}
            readOnly={true}
            text={formatMessage("JoinHealthInsurance")}
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={employee?.IsUnemploymentInsurance}
            readOnly={true}
            text={formatMessage("JoinUnemployementInsurance")}
          />
          <br />
          <br />
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("InsStartDate")}</div>
            <div className="form-value">
              <span>{convertDateTime(employee?.InsStartDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("HouseholdNo")}</div>
            <div className="form-value">
              <span>{employee?.HouseholdNo}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("InsuranceBookNo")}</div>
            <div className="form-value">
              <span>{employee?.InsuranceBookNo}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
